// src/utils/handleApiError.js
import { translateValue } from "../i18n";
import dictionary from "../i18n/dictionary";

/** t verilməyibsə lokal dictionary-dən oxuyur (kontekstdən kənar çağırışlar üçün) */
const fallbackT = (key) => translateValue(dictionary[key], localStorage.getItem("quizzo_lang") || "az");

/**
 * API xətasını istifadəçi dilində oxunaqlı mətnə çevirir.
 * İkinci arqument olaraq useI18n()-dan gələn `t` ötürülməlidir.
 */
export const handleApiError = (err, t = fallbackT) => {
  if (!err.response) {
    return t("errors.network");
  }

  const { status, data } = err.response;

  switch (status) {
    case 422:
      if (data?.errors?.phone?.includes("validation.unique")) {
        return t("errors.phone_taken");
      }
      return data?.message || t("errors.validation");

    case 401:
      return t("errors.unauthorized");
    case 402:
      // Abunəlik tələb olunur — mesaj backend-dən gəlir
      return data?.message || t("play.sub_required_default");
    case 403:
      return t("errors.forbidden");
    case 404:
      return t("errors.not_found");
    case 500:
      return t("errors.server");
    case 503:
      return t("errors.unavailable");
    default:
      return data?.message || t("errors.generic");
  }
};
